module.exports = {"420102002":"大智街","420102003":"一元街","420102004":"车站街","420102005":"四唯街","420102006":"永清街","420102007":"西马街","420102008":"球场街","420102009":"劳动街","420102010":"二七街","420102011":"新村街","420102012":"丹水池街","420102014":"台北街","420102015":"花桥街","420102016":"谌家矶街","420102017":"后湖街","420102018":"塔子湖街","420102400":"百步亭花园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420102.json
// module id = 1549
// module chunks = 0